module.exports = require("./ca-ES-VALENCIA.js");